@import '../../../../../constants/spacing.module.less';

.api-keys-v1-table {
  width: 100%;
  border-spacing: 0;
}

.api-keys-v1-table-head-th {
  text-align: left;
  padding: @space-12 @space-16;
  background-color: var(--gray-F1F2F3);
}

.api-keys-v1-table-td {
  text-align: left;
  padding: @space-16;
}

.api-keys-v1-table-tr:not(:last-of-type) td {
  border-bottom: 1px solid var(--grey-300);
}
